<nav aria-label="breadcrumb">
  <ol class="text-sm flex flex-wrap items-center pr-3 py-2 mb-2 bg-gray-100 rounded">
    <!-- Indicateur de chargement global -->
    <div *ngIf="isLoading" class="fixed top-0 left-0 z-50 w-full bg-blue-500" style="height: 3px;">
      <div class="progress-bar progress-bar-animated w-full h-full"></div>
    </div>
    
    <ng-container *ngFor="let item of items; let last = last; let i = index">
      <!-- Élément du fil d'ariane -->
      <li class="flex items-center h-6" [class.font-medium]="last" [attr.aria-current]="last ? 'page' : null">
        <!-- Élément avec URL (lien cliquable) -->
        <a *ngIf="item.url" 
           href="javascript:void(0)" 
           class="font-semibold  no-underline transition-colors duration-200 text-black hover:text-blue-600"
           (click)="reloadPage(item.url)">
          {{ item.label }}
        </a>
        
        <!-- Élément sans URL (style du premier élément) -->
        <span *ngIf="!item.url" class="text-gray-700">{{ item.label }}</span>
      </li>
      <!-- Séparateur ">" sauf pour le dernier élément -->
      <li *ngIf="!last" class="flex items-center h-6 mx-2 text-gray-500">></li>
    </ng-container>
  </ol>
</nav>